import { Link } from 'react-router-dom'
import itunes from '../../assets/img/brands/itunes.png'
import spotify from '../../assets/img/brands/spotify.png'
import bandcamp from '../../assets/img/brands/bandcamp.png'
import soundcloud from '../../assets/img/brands/soundcloud-round.png'

const streamingLinks = [
  { name: 'iTunes', path: 'https://itunes.apple.com/us/artist/melting-season/id421512974', icon: itunes },
  { name: 'Spotify', path: 'https://open.spotify.com/artist/6boh1qJVxPfYBayh7r1cbb?si=KYOhXRZKToG0mGefDk0VOg', icon: spotify },
  { name: 'Bandcamp', path: 'http://meltingseason.bandcamp.com/', icon: bandcamp },
  { name: 'Soundcloud', path: 'https://soundcloud.com/meltingseason', icon: soundcloud },
]

export default function SlideTwo() {
  return (
    <div className='slide slide-two'>
      <div className='container clearfix'>
        <div className='content grid-12'>
          <h1>
            <Link to='/closed-eye-visual'>
              CLOSED EYE VISUAL
            </Link>
          </h1>

          <iframe 
            title='soundcloud player'
            width='100%' 
            height='450' 
            scrolling='no' 
            frameBorder='no' 
            src='https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/14714888&amp;color=ff5500&amp;auto_play=false&amp;hide_related=false&amp;show_artwork=true' />
        </div>

        <div className='streaming-links' style={{ textAlign: 'center' }}>
          { streamingLinks.map( link =>
            <div className='work' key={ link.name }>
              <a className='image-link' href={ link.path }>
                <img 
                  src={ link.icon }
                  alt={ link.name } />
              </a>
            </div>
          ) }
        </div>
      </div>
    </div>
  )
}